export default __webpack_public_path__ + "static/media/wind-turbine-highlighted-icon.018e8dd3.svg";